export const ResponseColumnsASI =
  [
    'id',
    'asiCode',
    'authMethod',
    'description',
    'generation',
    'hwType',
    'make',
    'manufacturer',
    'platform',
    'region',
    'mpc'
  ];
export const ResponseColumnsASIV2 =
  [
    '_id',
    'asiCode',
    'authMethod',
    'description',
    'generation',
    'hwType',
    'make',
    'manufacturer',
    'platform',
    'region',
    'mpc',
    'platformSubType'
  ];
export const ASIProductColumnsV2 =
  [
    'asiCode',
    'hwType',
    'make',
    'region',
    'products'
  ];
const ResponseColumnsPackage =
  [
    'productID',
    'productName',
    'productCode',
    'fnaProductCode',
    'status',
    'brand',
    'region',
    'generation',
    'effectiveDate',
    'endDate',
    'term',
    'termUnit',
    'type',
    'price',
    'netPrice',
    'discount',
    'currency',
    'customerVisible',
    'renewable',
    'productStatus',
    'pendingStatus',
    'subscriptionEngineRatePlanID',
    'subscriptionEngineRatePlanChargeID'
  ];
export const ResponseColumnsPackageV1 = [...ResponseColumnsPackage];
export const ResponseColumnsPackageV2 = [...ResponseColumnsPackage, 'tags'];
